export enum InputSize {
  sm = '32px',
  md = '40px',
  lg = '48px',
}
